import React from "react";
import RawRequestViewer from "./RawRequestViewer";

const v1Columns = [
  { key: "channel_id", label: "Channel ID" },
  { key: "device_id", label: "Device Box ID" },
  { key: "start", label: "Start" },
  { key: "finish", label: "Finish" },
  { key: "people", label: "People Bits" },
  { key: "offline", label: "Offline/Data Seq" },
  { key: "temp", label: "Temperature" },
  { key: "error", label: "Error" },
  { key: "server_time", label: "Server Time" },
  { key: "ts_status", label: "TS Status" },
];

const RawRequestV1 = () => (
  <RawRequestViewer
    title="Device Raw Requests (v1)"
    endpointBuilder={(deviceBoxId) => `/raw/v1/${deviceBoxId}`}
    menuKey="rawrequestsv1"
    columns={v1Columns}
    helperText="Latest 500 packets stored by the legacy v1 ingestion flow."
  />
);

export default RawRequestV1;
